module.exports = __webpack_public_path__ + "img/referrals-active.d762b9a0.svg";